import { NumberInput, NumberInputProps } from '@mantine/core';
import classes from './Inputs.module.css';
import { useCapabilityHelpLabel } from '@/pages/Editor/components/StepSidebar/CapabilityHelpContext.tsx';

type StyledNumberInputProps = NumberInputProps & { capabilityFieldId?: string };

const StyledNumberInput = ({ capabilityFieldId, ...props }: StyledNumberInputProps) => {
  const label = useCapabilityHelpLabel(props.label, capabilityFieldId);
  return (
    <NumberInput
      hideControls
      {...props}
      label={label}
      classNames={{
        input: classes.input,
        label: classes.label,
      }}
    />
  );
};

export default StyledNumberInput;
